/**
 * Application shell.
 *
 * J1 only proves that the front end builds and is served by the backend.
 * The 3D scene (J9) and the game views (J11) will replace this placeholder.
 */
export default function App() {
  return (
    <main className="app">
      <h1>Lupus Ex Machina</h1>
      <p>Simulateur de parties de Loup-Garou jouées par des agents autonomes.</p>
      <p className="app__status">Moteur de jeu en place — la scène arrive.</p>
    </main>
  )
}
